import * as firebase from "firebase";
/*const firebaseConfig = {
    apiKey: "AIzaSyDpoybV46LL9s9Yoz2dkgdu7_4HwdYApwM",
    authDomain: "trivia-468fb.firebaseapp.com",
    databaseURL: "https://trivia-468fb.firebaseio.com",
    projectId: "trivia-468fb",
    storageBucket: "trivia-468fb.appspot.com",
    messagingSenderId: "542679762481"
};*/
const firebaseConfig = {
    apiKey: "AIzaSyAv8yxEEHKdN3WxehmUJY7G6DSWOBYyrO4",
    authDomain: "questions-59ee6.firebaseapp.com",
    databaseURL: "https://questions-59ee6.firebaseio.com",
    projectId: "questions-59ee6",
    storageBucket: "questions-59ee6.appspot.com",
    messagingSenderId: "418189060782"
};

const constants = {
    ACTIVE: "active",
    OFF : "off",
    STATUS : "status",
    GAMES : "games"
}
firebase.initializeApp(firebaseConfig);
var database = firebase.database();
var auth = firebase.auth();
export { firebaseConfig, database, auth, constants};


// WEBPACK FOOTER //
// ./src/config/index.js